import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-arrow-narrow-right-icon',
  templateUrl: 'arrow-narrow-right-icon.component.html'
})
export class ArrowNarrowRightIconComponent {
  constructor() {}
}
